export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ?? '';
export const TELEGRAM_BOT_URL = process.env.REACT_APP_TELEGRAM_BOT_URL ?? '';
